/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_By_MonthInputs */

const vi_my_grower_report_by_month = /** @type {(inputs: My_Grower_Report_By_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từng tháng`)
};

/**

* @param {My_Grower_Report_By_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_by_month = /** @type {((inputs?: My_Grower_Report_By_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_By_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_by_month(inputs)
});